
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontakt/[slug]",
      function () {
        return require("private-next-pages/kontakt/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kontakt/[slug]"])
      });
    }
  